// @flow


import type {SessionState} from '../types'
import type {SetUserPayload} from '../actions/setUser'

export function setUserReducer(state: SessionState, action: Action<SetUserPayload>): SessionState {
  const {
    user,
    idToken,
  } = action.payload

  return {
    ...state,
    user,
    idToken,
  }
}
